import { OfferDefaultsPage } from '@/pages/crm/settings/OfferDefaultsPage';
import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/crm/settings/offer-defaults')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['offers.manageSettings'], redirectTo: '/dashboard' }),
	component: OfferDefaultsPage,
});
